module.exports = __webpack_public_path__ + "static/media/ivn_alert_colored.27b3e4ca.svg";